import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {HttpProvider} from "../http/http";

/*
  Generated class for the SpeakSettingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SpeakSettingProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello SpeakSettingProvider Provider');
  }

  changeSwitch(is_open){
    return this.http.hPost('/contentdetect/switch',{'switch':is_open});
  }

  getSetting(){
    return this.http.hPost('/contentdetect/get_setting');
  }

  modifySetting(setting){
    if(typeof setting['member_whitelist'] == 'string'){
      setting['member_whitelist']= [];
    }
    return this.http.hPost('/contentdetect/operate',setting);
  }
}



// WEBPACK FOOTER //
// ./src/providers/speak-setting/speak-setting.ts